
const DESIGN_ID = '8f0af0eb-0000-0000-0000-mock00000006';

const designDocument = {
  ModularDesignType: 'WallStorage',
  Id: DESIGN_ID,
  DesignName: 'Mock Ryobi Wall Rail 2-Pack Bundle',
  Version: 1,
  ProductTypeId: 97,
  Sku: 334389625, // TODO: real single-SKU bundle Sku for the Wall Rail 2-pack
  Surface: null,
  Matrix: { Rows: 1, Columns: 10, Segments: null },
  Cart: [],
  IsLocked: false,
  ProductsHash: null,
  ProjectId: null,
  Created: '2026-01-01T00:00:00.000Z',
  LastModified: '2026-01-01T00:00:00.000Z',
  Products: [
    {
      InstanceId: 'ryobi-wall-rail-1',
      Type: 'Accessory',
      Sku: null,
      Name: 'RYOBI Wall Rail',
      ChoiceId: 500001,
      Origin: {
        Row: 0, Column: 0, Height: 400, Width: 4800,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 1,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'ryobi-wall-rail-2',
      Type: 'Accessory',
      Sku: null,
      Name: 'RYOBI Wall Rail',
      ChoiceId: 500001,
      Origin: {
        Row: 0, Column: 4400, Height: 400, Width: 4800,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 2,
      TargetArea: null,
      ChoiceBundle: null,
    },
  ],
};

const ryobiWallRailBundleMock = [
  {
    Id: DESIGN_ID,
    DesignDocument: JSON.stringify(designDocument),
  },
];

export default ryobiWallRailBundleMock;
